import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';

import { setAlert } from '../../../../actions/alert';
import { buscarAreasConfiguracion, crearOrganizadorConfiguracion } from '../../../../actions/configuracion';

import { CustomValueContainer } from '../../../../components/react_select/ReactSelect';

const NuevaOrganizador = ({ organizador, reestablecerOrganizador }) => {

    const dispatch =  useDispatch();

    const { listado: listado_areas } = useSelector(state => state.configuracion.areas);

    const [nuevoModal, setNuevoModal] = useState(false);
    const [statusProcesar, setStatusProcesar] = useState(false);

    const [organizadorData, setOrganizadorData] = useState({
        id: null,
        area: false,
        nombre: null
    });

    const [areaData, setAreaData] = useState(null);
    const [areasFilter, setAreasFilter] = useState([]);

    let styles_select = {
        menuPortal: base => ({ ...base, zIndex: 9999 }), 
        container: (provided, state) => ({
            ...provided
        }),
        valueContainer: (provided, state) => ({
            ...provided,
            paddingTop: '10px',
            paddingBottom: '5px',
            overflow: "visible", 
            marginTop: "10px"
        }),
        placeholder: (provided, state) => ({
            ...provided,
            position: "absolute",
            top: state.hasValue || state.selectProps.inputValue ? -15 : "0%",
            transition: "top 0.1s, font-size 0.1s",
            fontSize: (state.hasValue || state.selectProps.inputValue) && 13
        })
    };

    /* Crear organizador */
    const handleInputChange = ({ target }) => {
        setOrganizadorData({
            ...organizadorData,
            [target.name]: target.value
        });
    }

    const handleSelect = (option) => {
        setAreaData(option);

        setOrganizadorData({
            ...organizadorData,
            id: option != null ? option.value : null
        });
    }
    
    const handleProcesar = async () => {
        if(organizadorData.nombre && organizadorData.id != 0 && organizadorData.id != '0'){
            await setStatusProcesar(true);
            await dispatch(crearOrganizadorConfiguracion(organizadorData));
            await handleCerrar();
            await setStatusProcesar(false);
        }else{
            await dispatch(setAlert('Completa todos los campos', 'danger'));
        }
    }

    const handleCerrar = () => {
        if(!statusProcesar){
            setOrganizadorData({
                id: null,
                nombre: null
            });
            setAreaData(null);
            setNuevoModal(false);
            reestablecerOrganizador(null);
        }
    }

    useEffect(() => {
        dispatch(buscarAreasConfiguracion());
    }, []);

    useEffect(() => {
        if(organizador){
            setNuevoModal(true);

            setOrganizadorData({
                ...organizadorData, 
                id: organizador.id_area, 
                area: organizador.id_area == 0 ? false : true
            });
        }        
    }, [organizador]);

    useEffect(() => {
        let options = [];

        for (var i = 0; i < listado_areas.length; i++) {
            options.push({ value: listado_areas[i].id, label: listado_areas[i].nombre });
        }

        setAreasFilter(options);
    }, [listado_areas]);

    return (
        <Modal show={nuevoModal} size="md" backdrop="static" centered onHide={() => handleCerrar()}>
            <Modal.Header closeButton>
                <Modal.Title>Agregar organizador</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    {
                        organizador?.id_area == 0 || organizador?.id_area == '0' ?
                            <div className="col-md-12 form-group mb-2">
                                <div className="input-group h-100">
                                    <Select
                                        id="id"
                                        name="id"
                                        className="select-group"
                                        classNamePrefix="react-select"
                                        placeholder="Área"
                                        options={areasFilter}
                                        value={areaData}
                                        isClearable={true}
                                        onChange={(value) => handleSelect(value)}
                                        menuPortalTarget={document.body}
                                    menuPlacement="auto"
                                        components={{
                                            ValueContainer: CustomValueContainer
                                        }}
                                        styles={{ ...styles_select }}
                                    />
                                </div>
                            </div>
                        :
                            null
                    }

                    <div className="col-md-12 form-group mb-2">
                        <div className="input-group">
                            <div className="form-floating">
                                <input type="text" className="form-control" placeholder="Nombre" id="nombre" name="nombre" value={organizadorData.nombre} onChange={e => handleInputChange(e)}/>
                                <label htmlFor="nombre">Nombre</label>
                            </div>
                        </div>
                    </div>
                </div>                    
            </Modal.Body>
            <Modal.Footer>
                {
                    statusProcesar ?
                        <button type="button" className="btn btn-success" disabled><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Agregar</button>
                    :
                        <button type="button" className="btn btn-success" onClick={() => handleProcesar()}><i className="fas fa-check fa-sm"></i> Agregar</button>
                }
            </Modal.Footer>
        </Modal>
    )
}

export default NuevaOrganizador;